import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "impact-card" }
const _hoisted_2 = { class: "impact-card__content" }
const _hoisted_3 = { class: "impact-card__content-rating" }
const _hoisted_4 = { class: "impact-card__rating-bar" }
const _hoisted_5 = { class: "impact-card__footer" }
const _hoisted_6 = { class: "impact-card__footer-icons" }
const _hoisted_7 = { class: "impact-card__footer-images" }
const _hoisted_8 = ["src"]

import ViRatingBar from "@/components/elements/vi-rating-bar/vi-rating-bar.vue";
import { ISDGRating } from "@/modules/profile/services/data/sdg/sdg.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'sdg-impact-card',
  props: {
    data: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PxPanel, null, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "impact-card__header" }, [
          _createElementVNode("div", { class: "impact-card__header-title" }, [
            _createElementVNode("span", { class: "px-panel__title" }, "SDG Impacts"),
            _createElementVNode("span", null, "Updated: May 2025")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Vested Impact Rating", -1)),
          _createElementVNode("span", null, _toDisplayString(__props.data.rating), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.data.score), 1),
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "-100", -1)),
            _createVNode(ViRatingBar, {
              size: "large",
              type: "double",
              negative: __props.data.negativeImpact,
              positive: __props.data.positiveImpact
            }, null, 8, ["negative", "positive"]),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "+100", -1))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Vested Impact Score", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "TOP POSITIVELY IMPACTED SDG'S", -1)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.topPositivelyImpactedSDGs, (sdg) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: sdg,
                  src: `/img/sdg/${sdg}.png`
                }, null, 8, _hoisted_8))
              }), 128))
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "impact-card__footer-details" }, " The Sustainable Development Goals (SDGs) are 17 global objectives established by the United Nations in 2015 to end poverty, protect the planet, and promote peace and prosperity by 2030. ", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "impact-card__footer-links" }, [
            _createElementVNode("span", null, "How impact is measured"),
            _createElementVNode("span", { class: "impact-card__footer-links-vi" }, [
              _createTextVNode(" Data provided by "),
              _createElementVNode("span", null, "Vested Impact")
            ])
          ], -1))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})